// extracted by mini-css-extract-plugin
export var active = "_l6-e";
export var blink = "_l6-f";
export var dropDownSelector = "_l6-5";
export var dropDownWrapper = "_l6-4";
export var fakeCursor = "_l6-d";
export var fontSizeButton = "_l6-7";
export var formQuillEditor = "_l6-0";
export var pressed = "_l6-g";
export var qlBlank = "_l6-1";
export var textFormattingToolbar = "_l6-2";
export var textFormattingToolbarClosed = "_l6-3";
export var textFormattingToolbarInline = "_l6-6";
export var textToolbarOption = "_l6-8";
export var toolbarCell = "_l6-a";
export var toolbarCellCollapsed = "_l6-b";
export var toolbarOptionHitArea = "_l6-c";
export var toolbarOverflow = "_l6-9";